/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  Entity,
  EntityCreate,
  EntityDocumentCreate,
  EntityDocumentRead,
  EntityRead,
  GetEntitiesParams,
  GetStripeBalanceTransactionsParams,
  HTTPValidationError,
  PageEntityManyRead,
  StripeBalanceSummary,
  StripeBalanceTransactionPage,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new entity.
 * @summary Create Entity
 */
export const createEntity = (
  entityCreate: EntityCreate,
  signal?: AbortSignal,
) => {
  return customInstance<Entity>({
    url: `/api/entity/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: entityCreate,
    signal,
  });
};

export const getCreateEntityMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEntity>>,
    TError,
    { data: EntityCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEntity>>,
  TError,
  { data: EntityCreate },
  TContext
> => {
  const mutationKey = ["createEntity"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEntity>>,
    { data: EntityCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createEntity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEntity>>
>;
export type CreateEntityMutationBody = EntityCreate;
export type CreateEntityMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Entity
 */
export const useCreateEntity = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEntity>>,
      TError,
      { data: EntityCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEntity>>,
  TError,
  { data: EntityCreate },
  TContext
> => {
  const mutationOptions = getCreateEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many entities.

- **entity_types**: List of entity types to filter by.

No permission is required, since this will filter to only entities the user has access to.
 * @summary Get Entities
 */
export const getEntities = (
  params?: GetEntitiesParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageEntityManyRead>({
    url: `/api/entity/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetEntitiesInfiniteQueryKey = (params?: GetEntitiesParams) => {
  return ["infinite", "api", "entity", ...(params ? [params] : [])] as const;
};

export const getGetEntitiesQueryKey = (params?: GetEntitiesParams) => {
  return ["api", "entity", ...(params ? [params] : [])] as const;
};

export const getGetEntitiesInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getEntities>>,
    GetEntitiesParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetEntitiesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getEntities>>,
        TError,
        TData,
        QueryKey,
        GetEntitiesParams["page"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEntitiesInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEntities>>,
    QueryKey,
    GetEntitiesParams["page"]
  > = ({ signal, pageParam }) =>
    getEntities({ ...params, page: pageParam || params?.["page"] }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getEntities>>,
    TError,
    TData,
    QueryKey,
    GetEntitiesParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntitiesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntities>>
>;
export type GetEntitiesInfiniteQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetEntitiesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getEntities>>,
    GetEntitiesParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetEntitiesParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getEntities>>,
        TError,
        TData,
        QueryKey,
        GetEntitiesParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntities>>,
          TError,
          Awaited<ReturnType<typeof getEntities>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntitiesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getEntities>>,
    GetEntitiesParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetEntitiesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getEntities>>,
        TError,
        TData,
        QueryKey,
        GetEntitiesParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntities>>,
          TError,
          Awaited<ReturnType<typeof getEntities>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntitiesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getEntities>>,
    GetEntitiesParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetEntitiesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getEntities>>,
        TError,
        TData,
        QueryKey,
        GetEntitiesParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Entities
 */

export function useGetEntitiesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getEntities>>,
    GetEntitiesParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetEntitiesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getEntities>>,
        TError,
        TData,
        QueryKey,
        GetEntitiesParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEntitiesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetEntitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntities>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntities>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEntitiesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntities>>> = ({
    signal,
  }) => getEntities(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEntities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntities>>
>;
export type GetEntitiesQueryError = ErrorType<void | HTTPValidationError>;

export function useGetEntities<
  TData = Awaited<ReturnType<typeof getEntities>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetEntitiesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntities>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntities>>,
          TError,
          Awaited<ReturnType<typeof getEntities>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntities<
  TData = Awaited<ReturnType<typeof getEntities>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntities>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntities>>,
          TError,
          Awaited<ReturnType<typeof getEntities>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntities<
  TData = Awaited<ReturnType<typeof getEntities>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntities>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Entities
 */

export function useGetEntities<
  TData = Awaited<ReturnType<typeof getEntities>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetEntitiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntities>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEntitiesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an entity by ID.
 * @summary Get Entity
 */
export const getEntity = (entityId: number, signal?: AbortSignal) => {
  return customInstance<EntityRead>({
    url: `/api/entity/${entityId}`,
    method: "GET",
    signal,
  });
};

export const getGetEntityQueryKey = (entityId?: number) => {
  return ["api", "entity", entityId] as const;
};

export const getGetEntityQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntity>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEntityQueryKey(entityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntity>>> = ({
    signal,
  }) => getEntity(entityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!entityId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetEntityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntity>>
>;
export type GetEntityQueryError = ErrorType<void | HTTPValidationError>;

export function useGetEntity<
  TData = Awaited<ReturnType<typeof getEntity>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntity>>,
          TError,
          Awaited<ReturnType<typeof getEntity>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntity<
  TData = Awaited<ReturnType<typeof getEntity>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntity>>,
          TError,
          Awaited<ReturnType<typeof getEntity>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntity<
  TData = Awaited<ReturnType<typeof getEntity>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Entity
 */

export function useGetEntity<
  TData = Awaited<ReturnType<typeof getEntity>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEntityQueryOptions(entityId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an entity by ID.
 * @summary Update Entity
 */
export const updateEntity = (entityId: number, entityCreate: EntityCreate) => {
  return customInstance<Entity>({
    url: `/api/entity/${entityId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: entityCreate,
  });
};

export const getUpdateEntityMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEntity>>,
    TError,
    { entityId: number; data: EntityCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEntity>>,
  TError,
  { entityId: number; data: EntityCreate },
  TContext
> => {
  const mutationKey = ["updateEntity"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEntity>>,
    { entityId: number; data: EntityCreate }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return updateEntity(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEntity>>
>;
export type UpdateEntityMutationBody = EntityCreate;
export type UpdateEntityMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Entity
 */
export const useUpdateEntity = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEntity>>,
      TError,
      { entityId: number; data: EntityCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEntity>>,
  TError,
  { entityId: number; data: EntityCreate },
  TContext
> => {
  const mutationOptions = getUpdateEntityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Enable the MFA enrollment requirement for an entity.

This is enable-only; the requirement cannot be turned off through the API. Requires
the administrate_users permission.
 * @summary Enable Entity Require Mfa
 */
export const enableEntityRequireMfa = (
  entityId: number,
  signal?: AbortSignal,
) => {
  return customInstance<Entity>({
    url: `/api/entity/${entityId}/require-mfa`,
    method: "POST",
    signal,
  });
};

export const getEnableEntityRequireMfaMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enableEntityRequireMfa>>,
    TError,
    { entityId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enableEntityRequireMfa>>,
  TError,
  { entityId: number },
  TContext
> => {
  const mutationKey = ["enableEntityRequireMfa"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enableEntityRequireMfa>>,
    { entityId: number }
  > = (props) => {
    const { entityId } = props ?? {};

    return enableEntityRequireMfa(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnableEntityRequireMfaMutationResult = NonNullable<
  Awaited<ReturnType<typeof enableEntityRequireMfa>>
>;

export type EnableEntityRequireMfaMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Enable Entity Require Mfa
 */
export const useEnableEntityRequireMfa = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enableEntityRequireMfa>>,
      TError,
      { entityId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof enableEntityRequireMfa>>,
  TError,
  { entityId: number },
  TContext
> => {
  const mutationOptions = getEnableEntityRequireMfaMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get all documents for an entity.
 * @summary Get Entity Documents
 */
export const getEntityDocuments = (entityId: number, signal?: AbortSignal) => {
  return customInstance<EntityDocumentRead[]>({
    url: `/api/entity/${entityId}/documents`,
    method: "GET",
    signal,
  });
};

export const getGetEntityDocumentsQueryKey = (entityId?: number) => {
  return ["api", "entity", entityId, "documents"] as const;
};

export const getGetEntityDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntityDocuments>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDocuments>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEntityDocumentsQueryKey(entityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEntityDocuments>>
  > = ({ signal }) => getEntityDocuments(entityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!entityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEntityDocuments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntityDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEntityDocuments>>
>;
export type GetEntityDocumentsQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetEntityDocuments<
  TData = Awaited<ReturnType<typeof getEntityDocuments>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDocuments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntityDocuments>>,
          TError,
          Awaited<ReturnType<typeof getEntityDocuments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntityDocuments<
  TData = Awaited<ReturnType<typeof getEntityDocuments>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDocuments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntityDocuments>>,
          TError,
          Awaited<ReturnType<typeof getEntityDocuments>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEntityDocuments<
  TData = Awaited<ReturnType<typeof getEntityDocuments>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDocuments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Entity Documents
 */

export function useGetEntityDocuments<
  TData = Awaited<ReturnType<typeof getEntityDocuments>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEntityDocuments>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEntityDocumentsQueryOptions(entityId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to upload a document for an entity.
 * @summary Create Entity Document
 */
export const createEntityDocument = (
  entityId: number,
  entityDocumentCreate: EntityDocumentCreate,
  signal?: AbortSignal,
) => {
  return customInstance<EntityDocumentRead>({
    url: `/api/entity/${entityId}/documents`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: entityDocumentCreate,
    signal,
  });
};

export const getCreateEntityDocumentMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEntityDocument>>,
    TError,
    { entityId: number; data: EntityDocumentCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEntityDocument>>,
  TError,
  { entityId: number; data: EntityDocumentCreate },
  TContext
> => {
  const mutationKey = ["createEntityDocument"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEntityDocument>>,
    { entityId: number; data: EntityDocumentCreate }
  > = (props) => {
    const { entityId, data } = props ?? {};

    return createEntityDocument(entityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEntityDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEntityDocument>>
>;
export type CreateEntityDocumentMutationBody = EntityDocumentCreate;
export type CreateEntityDocumentMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Entity Document
 */
export const useCreateEntityDocument = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEntityDocument>>,
      TError,
      { entityId: number; data: EntityDocumentCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEntityDocument>>,
  TError,
  { entityId: number; data: EntityDocumentCreate },
  TContext
> => {
  const mutationOptions = getCreateEntityDocumentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to delete a document for an entity.
 * @summary Delete Entity Document
 */
export const deleteEntityDocument = (
  entityId: number,
  entityDocumentId: number,
) => {
  return customInstance<unknown>({
    url: `/api/entity/${entityId}/documents/${entityDocumentId}`,
    method: "DELETE",
  });
};

export const getDeleteEntityDocumentMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEntityDocument>>,
    TError,
    { entityId: number; entityDocumentId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEntityDocument>>,
  TError,
  { entityId: number; entityDocumentId: number },
  TContext
> => {
  const mutationKey = ["deleteEntityDocument"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEntityDocument>>,
    { entityId: number; entityDocumentId: number }
  > = (props) => {
    const { entityId, entityDocumentId } = props ?? {};

    return deleteEntityDocument(entityId, entityDocumentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteEntityDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEntityDocument>>
>;

export type DeleteEntityDocumentMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Delete Entity Document
 */
export const useDeleteEntityDocument = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEntityDocument>>,
      TError,
      { entityId: number; entityDocumentId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEntityDocument>>,
  TError,
  { entityId: number; entityDocumentId: number },
  TContext
> => {
  const mutationOptions = getDeleteEntityDocumentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get the number of outstanding requirements for a Stripe Connect account.
 * @summary Get Stripe Account Requirements
 */
export const getStripeAccountRequirements = (
  entityId: number,
  signal?: AbortSignal,
) => {
  return customInstance<number>({
    url: `/api/entity/stripe/account-requirements/${entityId}`,
    method: "GET",
    signal,
  });
};

export const getGetStripeAccountRequirementsQueryKey = (entityId?: number) => {
  return ["api", "entity", "stripe", "account-requirements", entityId] as const;
};

export const getGetStripeAccountRequirementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStripeAccountRequirements>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeAccountRequirements>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStripeAccountRequirementsQueryKey(entityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStripeAccountRequirements>>
  > = ({ signal }) => getStripeAccountRequirements(entityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!entityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStripeAccountRequirements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStripeAccountRequirementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStripeAccountRequirements>>
>;
export type GetStripeAccountRequirementsQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetStripeAccountRequirements<
  TData = Awaited<ReturnType<typeof getStripeAccountRequirements>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeAccountRequirements>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStripeAccountRequirements>>,
          TError,
          Awaited<ReturnType<typeof getStripeAccountRequirements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStripeAccountRequirements<
  TData = Awaited<ReturnType<typeof getStripeAccountRequirements>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeAccountRequirements>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStripeAccountRequirements>>,
          TError,
          Awaited<ReturnType<typeof getStripeAccountRequirements>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStripeAccountRequirements<
  TData = Awaited<ReturnType<typeof getStripeAccountRequirements>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeAccountRequirements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Stripe Account Requirements
 */

export function useGetStripeAccountRequirements<
  TData = Awaited<ReturnType<typeof getStripeAccountRequirements>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeAccountRequirements>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStripeAccountRequirementsQueryOptions(
    entityId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to create a new Stripe Connect account.

Used to register a new entity with Stripe.
 * @summary Create Stripe Connect Account
 */
export const createStripeConnectAccount = (
  entityId: number,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>({
    url: `/api/entity/stripe/create-connect-account/${entityId}`,
    method: "POST",
    signal,
  });
};

export const getCreateStripeConnectAccountMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStripeConnectAccount>>,
    TError,
    { entityId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStripeConnectAccount>>,
  TError,
  { entityId: number },
  TContext
> => {
  const mutationKey = ["createStripeConnectAccount"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStripeConnectAccount>>,
    { entityId: number }
  > = (props) => {
    const { entityId } = props ?? {};

    return createStripeConnectAccount(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStripeConnectAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStripeConnectAccount>>
>;

export type CreateStripeConnectAccountMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Stripe Connect Account
 */
export const useCreateStripeConnectAccount = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createStripeConnectAccount>>,
      TError,
      { entityId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createStripeConnectAccount>>,
  TError,
  { entityId: number },
  TContext
> => {
  const mutationOptions = getCreateStripeConnectAccountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns summary metrics for a connected Stripe account.
 * @summary Get Stripe Balance Summary
 */
export const getStripeBalanceSummary = (
  entityId: number,
  signal?: AbortSignal,
) => {
  return customInstance<StripeBalanceSummary>({
    url: `/api/entity/stripe/balance-summary/${entityId}`,
    method: "GET",
    signal,
  });
};

export const getGetStripeBalanceSummaryQueryKey = (entityId?: number) => {
  return ["api", "entity", "stripe", "balance-summary", entityId] as const;
};

export const getGetStripeBalanceSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getStripeBalanceSummary>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeBalanceSummary>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStripeBalanceSummaryQueryKey(entityId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStripeBalanceSummary>>
  > = ({ signal }) => getStripeBalanceSummary(entityId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!entityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStripeBalanceSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStripeBalanceSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStripeBalanceSummary>>
>;
export type GetStripeBalanceSummaryQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetStripeBalanceSummary<
  TData = Awaited<ReturnType<typeof getStripeBalanceSummary>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeBalanceSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStripeBalanceSummary>>,
          TError,
          Awaited<ReturnType<typeof getStripeBalanceSummary>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStripeBalanceSummary<
  TData = Awaited<ReturnType<typeof getStripeBalanceSummary>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeBalanceSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStripeBalanceSummary>>,
          TError,
          Awaited<ReturnType<typeof getStripeBalanceSummary>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStripeBalanceSummary<
  TData = Awaited<ReturnType<typeof getStripeBalanceSummary>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeBalanceSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Stripe Balance Summary
 */

export function useGetStripeBalanceSummary<
  TData = Awaited<ReturnType<typeof getStripeBalanceSummary>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeBalanceSummary>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStripeBalanceSummaryQueryOptions(
    entityId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a paginated page of balance transactions for a connected Stripe account.
 * @summary Get Stripe Balance Transactions
 */
export const getStripeBalanceTransactions = (
  entityId: number,
  params?: GetStripeBalanceTransactionsParams,
  signal?: AbortSignal,
) => {
  return customInstance<StripeBalanceTransactionPage>({
    url: `/api/entity/stripe/balance-transactions/${entityId}`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetStripeBalanceTransactionsQueryKey = (
  entityId?: number,
  params?: GetStripeBalanceTransactionsParams,
) => {
  return [
    "api",
    "entity",
    "stripe",
    "balance-transactions",
    entityId,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStripeBalanceTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  params?: GetStripeBalanceTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStripeBalanceTransactionsQueryKey(entityId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStripeBalanceTransactions>>
  > = ({ signal }) => getStripeBalanceTransactions(entityId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!entityId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStripeBalanceTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStripeBalanceTransactions>>
>;
export type GetStripeBalanceTransactionsQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetStripeBalanceTransactions<
  TData = Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  params: undefined | GetStripeBalanceTransactionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
          TError,
          Awaited<ReturnType<typeof getStripeBalanceTransactions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStripeBalanceTransactions<
  TData = Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  params?: GetStripeBalanceTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
          TError,
          Awaited<ReturnType<typeof getStripeBalanceTransactions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStripeBalanceTransactions<
  TData = Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  params?: GetStripeBalanceTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Stripe Balance Transactions
 */

export function useGetStripeBalanceTransactions<
  TData = Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  entityId: number,
  params?: GetStripeBalanceTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStripeBalanceTransactions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStripeBalanceTransactionsQueryOptions(
    entityId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to create a new Stripe account link.
 * @summary Create Stripe Account Link
 */
export const createStripeAccountLink = (
  entityId: number,
  signal?: AbortSignal,
) => {
  return customInstance<string>({
    url: `/api/entity/stripe/create-account-link/${entityId}`,
    method: "POST",
    signal,
  });
};

export const getCreateStripeAccountLinkMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createStripeAccountLink>>,
    TError,
    { entityId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createStripeAccountLink>>,
  TError,
  { entityId: number },
  TContext
> => {
  const mutationKey = ["createStripeAccountLink"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createStripeAccountLink>>,
    { entityId: number }
  > = (props) => {
    const { entityId } = props ?? {};

    return createStripeAccountLink(entityId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateStripeAccountLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof createStripeAccountLink>>
>;

export type CreateStripeAccountLinkMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Stripe Account Link
 */
export const useCreateStripeAccountLink = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createStripeAccountLink>>,
      TError,
      { entityId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createStripeAccountLink>>,
  TError,
  { entityId: number },
  TContext
> => {
  const mutationOptions = getCreateStripeAccountLinkMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
